export const formOrderObjFromCart = (data = null) => {
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        // region: environmentDetails?.region || null,
        // regionDisplayName: { label: environmentDetails?.region || null, value: environmentDetails?.region || null },
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        awsAccountId: catalogConfig?.awsAccountId || null,
        functionName: catalogConfig?.lambdaFunctionName || null,
        architecture: catalogConfig?.architecture || null,
        memory: catalogConfig?.memorySize,
        timeout: catalogConfig?.timeout || '',
        runtime: catalogConfig?.runtime || null,
        handler: catalogConfig?.handler || '',
        imageUrl: catalogConfig?.containerImageUrl,
        appCodeRepository: catalogConfig?.codeDeploymentMethod === 'Code Repository' ? 'uploadCodeRepository' : 'containerImage',
        ...(catalogConfig?.codeDeploymentMethod === 'Code Repository' && {
            adoProject: catalogConfig?.adoProject || null,
            repository: catalogConfig?.repository || null,
            branch: catalogConfig?.branch || '',
        }),
        enableVpc: catalogConfig?.enableVpc ? 'Yes' : 'No',
        ...(catalogConfig?.enableVpc && {
            vpc: environmentDetails?.vpcId || null,
            connectivityType: catalogConfig?.connectivityType || null,
        }),
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        appRegion: catalogConfig?.applicationRegion || null,
        department: catalogConfig?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        awsAccountId: catalogConfig?.awsAccountId || null,
        functionName: catalogConfig?.lambdaFunctionName || null,
        architecture: catalogConfig?.architecture || null,
        memory: catalogConfig?.memorySize,
        timeout: catalogConfig?.timeout || '',
        runtime: catalogConfig?.runtime || null,
        handler: catalogConfig?.handler || '',
        imageUrl: catalogConfig?.containerImageUrl,
        appCodeRepository: catalogConfig?.codeDeploymentMethod === 'Code Repository' ? 'uploadCodeRepository' : 'containerImage',
        ...(catalogConfig?.codeDeploymentMethod === 'Code Repository' && {
            adoProject: catalogConfig?.adoProject || null,
            repository: catalogConfig?.repository || null,
            branch: catalogConfig?.branch || '',
        }),
        enableVpc: catalogConfig?.enableVpc ? 'Yes' : 'No',
        ...(catalogConfig?.enableVpc && {
            vpc: environmentDetails?.vpcId || null,
            connectivityType: catalogConfig?.connectivityType || null,
        }),
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    applicationName: null,
    appShortName: null,
    appProfile: null,
    entityDetails: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,

    // Resource Section
    awsAccount: null,
    awsAccountId: null,
    functionName: null,
    architecture: null,
    appSupportTeamName: null,

    // Application Component Security Group Section
    componentName: null,
    componentNameDetails: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const commonRegex =
    /^(https?:\/\/)(?!.*(?:secure\.pepsico|secure\.mypepsico|secure\.ite\.pepsico|secure\.ite\.mypepsico|secure\.it\.pepsico|secure\.it\.mypepsico|okta|oktapreview|oktadebugger|oidcdebugger|localhost))([a-zA-Z0-9\-_:/.?=@]+)$/i;

export const environmentConfig = {
    development: {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
    qa: {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
    'pre-production': {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
    production: {
        regex: commonRegex,
        message: `URL is Invalid.`,
    },
};

export const validateAppURL = (url, environment) => {
    if (!url || url === '') {
        return { isValid: true, message: '' };
    }

    const config = environmentConfig[environment?.toLowerCase()];
    if (!config) {
        return { isValid: false, message: 'Invalid environment specified' };
    }

    const isValid = config.regex.test(url);
    return {
        isValid,
        message: isValid ? '' : config.message,
    };
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const costPayload = ({ order = [], catalogCode, catalogServiceId }) => {
    const payload = {
        ...(catalogServiceId && { catalogServiceId }),
        catalogServiceCode: catalogCode,
        quantity: 1,
        catalogConfig: {
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
            },
            memorySize: order?.memory,
        },
    };
    return payload;
};
